/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RecognitionDisplay
 */
export interface RecognitionDisplay {
  /**
   *
   * @type {string}
   * @memberof RecognitionDisplay
   */
  direction: RecognitionDisplayDirectionEnum;
}

export const RecognitionDisplayDirectionEnum = {
  Ltr: 'ltr',
  Rtl: 'rtl',
} as const;

export type RecognitionDisplayDirectionEnum =
  (typeof RecognitionDisplayDirectionEnum)[keyof typeof RecognitionDisplayDirectionEnum];
